/* eslint-disable camelcase */
type Locale = 'en' | 'es';
type Phrase = (l: Locale) => string;

export const i18n_thousands_of_high_quality_classes: Phrase = locale => {
  const phrases: { [key in Locale]: string } = {
    en: `Thousands of high-quality yoga classes to meet you where you are, on your schedule.`,
    es: `Miles de clases de yoga en alta calidad para que practiques cuándo quieres y en dónde quieras`,
  };
  return phrases[locale] || phrases.en;
};
